import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { OutputsDetailsDialogComponent } from '../dialogs/outputs-details-dialog/outputs-details-dialog.component';
import { DeviceDetailsDialogComponent } from '../dialogs/device-details-dialog/device-details-dialog.component';
import { StrobesDetailsDialogComponent } from '../dialogs/strobes-details-dialog/strobes-details-dialog.component';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { MatListOption, MatSelectionListChange } from '@angular/material/list';
import e from 'express';
import { timeZoneService } from 'src/app/services/timezone.service';
import { AppConstants, hasPrivilege } from 'src/app/shared/app-constants';
import { ConfigService } from 'src/app/services/config.service';
import { SiteCamLiveViewsComponent } from '../dialogs/site-cam-live-views/site-cam-live-views.component';
import { IframeModalComponent } from 'src/app/iframe-modal/iframe-modal.component';

export const ANALYTIC_PLATEFORM = [
  { id: "3", name: "IVigil", value: "IVIGIL" },
  // { id: "2,4", name: "Axis Analytic (2, 4)", value: "AXIS_ANALYTIC (2, 4)" },
  { id: "7", name: "HD (7)", value: "HD (7)" },
  { id: "8", name: "HD Test (8)", value: "HD_TEST (8)" },
  { id: "10", name: "HD_EDGE (10)", value: "HD_EDGE (10)" },
  { id: "11", name: "HD_Realtime (11)", value: "HD_REALTIME (11)" },
  { id: "11", name: "HD_Realtime 11H", value: "HD_REALTIME 11H" },
  { id: "12", name: "CLOUD_NAS (12)", value: "CLOUD_NAS (12)" },
]
export const DEVICE_CONFIGURATION = [
  { id: "1", name: "Device Configuration", value: "OTHER_DEVICE_DATA" },
  { id: "2", name: "Output Configuration", value: "OUTPUT_DATA" },
  { id: "3", name: "Algo Strobe Configuration", value: "STROBE_DATA" },
]
export interface TableElementCamera {
  unique_id: number;
  camera_id: string;
  cameraName: string;
  cameraType: string;
  siteName: string;
  active: boolean;
  analytic_name: string;
  connected: string;
}
export interface TableElementDevice {
  deviceUniqueId: number;
  deviceName: string;
  deviceType: string;
  siteName: string;
}

export interface TableElementOutputs {
  deviceUniqueId: number;
  displayName: string;
  type: string;
  siteName: string;
  ipaddress: string;
  port: string;
}
export interface TableElementStrobes {
  deviceUniqueId: number;
  strobeId: string;
  name: string;
  siteName: string;
  portno: string;
}
@Component({
  selector: 'app-add-edit-site-list',
  templateUrl: './add-edit-site-list.component.html',
  styleUrls: ['./add-edit-site-list.component.scss']
,
  standalone: false
})
export class AddEditSiteListComponent implements OnInit, AfterViewInit {

  selectedSiteObject: any = {};
  selectedTab: number = 0;
  accountId: string = "";
  potentialId: string = "";
  potentialName: string = "";
  monitoringHours: string = "";
  aditionalhours: string = "";
  monitoringService: string = "";
  monitoredCamera: string = "";
  stopCaptureOutsideMonitor: boolean;
  evntMonitoring: boolean;
  siteStatus: string = "";
  company: string = "";
  siteJobs: string = "";
  secondarySecurity: string = "";
  sssContact: string = "";
  ouatageNotificationMethods: string = "";
  unitId: string = "";
  polishDepartmentName: string = "";
  installationType: string = "";
  fieldServicRep: string = "";
  occupied: boolean = false;
  emergencyPrimaryContact: string = "";
  emergencySecondaryContact: string = "";
  address: string = "";
  emailAddresss: string = "";
  city: string = "";
  safeWard: string = "";
  crossStreet: string = "";
  crossStreet2: string = "";
  state: string = "";
  zip: string = "";
  internetSource: string = "";
  contactOwnerFirst: any = false;
  localPolish: string = "";
  alarmBusinessLicence: string = "";
  alarmCustomerLicence: string = "";
  gateCode: string = "";
  gaurdTourTime: string = "";

  description: any
  analyticPlateform: any = ANALYTIC_PLATEFORM;
  selectedAnalyticPlateformID: any = "";
  isUpdateAnalyticPlatformBtn: boolean = true;

  cameraListForSite: any = [];
  selectedCameraNameFromList: string = "";
  isCameraSelected: boolean = false;
  loading: boolean = false;
  dayImage: any = [];
  isIcockpit: boolean = false;

  searchCameraFilterValue: string = ''
  displayedColumnsCamera: string[] = ['select', 'unique_id', 'cameraName', 'cameraType', 'siteName', 'active', 'analytic_name', 'connected', 'action'];
  displayedColumnsDevice: string[] = ['select', 'deviceUniqueId', 'deviceName', 'deviceType', 'siteName', 'action'];
  displayedColumnsOutputs: string[] = ['select', 'deviceUniqueId', 'displayName', 'type', 'siteName', 'ipaddress', 'port', 'action'];
  displayedColumnsStrobes: string[] = ['select', 'deviceUniqueId', 'strobeId', 'siteName', 'name', 'portno', 'action'];
  dataSourceCamera = new MatTableDataSource<TableElementCamera>([]);
  dataSourceDevice = new MatTableDataSource<TableElementDevice>([]);
  dataSourceOutputs = new MatTableDataSource<TableElementOutputs>([]);
  dataSourceStrobes = new MatTableDataSource<TableElementStrobes>([]);
  selection = new SelectionModel<TableElementCamera>(true, []);
  totalRecordsCamera: number = 0;
  pageSizeCamera: number = 10;
  pageIndexCamera: number = 0;
  selectRow: any = [];
  selectAllRow: any = [];

  selectionDevice = new SelectionModel<TableElementDevice>(true, []);
  totalRecordsDevice: number = 0;
  pageSizeDevice: number = 10;
  pageIndexDevice: number = 0;
  selectRowDevice: any = [];
  selectAllRowDevice: any = [];

  selectionOutputs = new SelectionModel<TableElementOutputs>(true, []);
  totalRecordsOutputs: number = 0;
  pageSizeOutputs: number = 10;
  pageIndexOutputs: number = 0;
  selectRowOutputs: any = [];
  selectAllRowOutputs: any = [];

  selectionStrobes = new SelectionModel<TableElementStrobes>(true, []);
  totalRecordsStrobes: number = 0;
  pageSizeStrobes: number = 10;
  pageIndexStrobes: number = 0;
  selectRowStrobes: any = [];
  selectAllRowStrobes: any = [];

  isLoadingResults = true;
  isRateLimitReached = false;
  selectDeviceConfiguration: string = "OTHER_DEVICE_DATA";
  deviceConfigurationList: any = DEVICE_CONFIGURATION;

  isEditDevice: boolean = false;
  dayImageUrl: any = '';
  nightImageUrl: any = '';

  selectSiteFile: any = '';
  uploadedPriviewImageFile: any = '';
  lastModifiedTime: any;

  hasEditPrivilege: boolean = false;
  hasViewCamPrivilege: boolean = false;
  isLiveViewEnabled: boolean = false;
  importCameraFileError: boolean = false;
  isLoadingCamera: boolean = false;
  selectedCameraName: string = '';
  selectedCameraUniqueId: string = '';
  selectedCameraStatus: boolean = false;
  siteInfo: any = {};
  isCameraSettingFeature: boolean = false;
  selectedCamObjectViews: any = {};
  indexNoOfSelectedCam: number = 0;

  @ViewChild('paginatorCamera') paginatorCamera: MatPaginator;
  @ViewChild("sortCamera") sortCamera: MatSort;

  @ViewChild('devicePaginator') devicePaginator: MatPaginator;
  @ViewChild("deviceSort") deviceSort: MatSort;

  @ViewChild('outputPaginator') outputPaginator: MatPaginator;
  @ViewChild("outputSort") outputSort: MatSort;

  @ViewChild('strobePaginator') strobePaginator: MatPaginator;
  @ViewChild("strobeSort") strobeSort: MatSort;

  constructor(
    private router: Router,
    private ngbModalService: NgbModal,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    private _location: Location,
    public dialog: MatDialog,
    private timeZoneService: timeZoneService,
    public configService: ConfigService,
  ) { }

  ngOnInit(): void {
    this.isLiveViewEnabled = this.configService.isFeatureEnabled('liveView');
    this.selectedTab = parseInt(localStorage.getItem("selectedTab"));
    this.selectDeviceConfiguration = "OTHER_DEVICE_DATA";
    this.potentialId = sessionStorage.getItem("potentialId");
    this.isIcockpit = this.configService.isFeatureEnabled('isIcockpit');
    this.isCameraSettingFeature = this.configService.isFeatureEnabled('isCameraSetting');
    if (this.potentialId) {
      this.getAllDevices();
      this.siteByPotentialID();
      this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
      // this.changePaging({ length: this.totalRecordsCamera, pageIndex: this.pageIndexCamera, pageSize: this.pageSizeCamera })

    }
    if (hasPrivilege('edit camera configuration')) {
      this.hasEditPrivilege = true;
    }
    if (hasPrivilege('view camera configuration')) {
      this.hasViewCamPrivilege = true;
    }
    this.indexNoOfSelectedCam = 0;
    sessionStorage.removeItem("selectedCamObjectInViews");
  }

  ngAfterViewInit() {
    this.dataSourceCamera.paginator = this.paginatorCamera;
    this.pageIndexCamera = this.paginatorCamera?.pageIndex;
    this.pageSizeCamera = this.paginatorCamera?.pageSize;

    this.dataSourceDevice.paginator = this.devicePaginator;
    this.pageIndexDevice = this.devicePaginator?.pageIndex;
    this.pageSizeDevice = this.devicePaginator?.pageSize;

    this.dataSourceStrobes.paginator = this.strobePaginator;
    this.pageIndexStrobes = this.strobePaginator?.pageIndex;
    this.pageSizeStrobes = this.strobePaginator?.pageSize;

    this.dataSourceOutputs.paginator = this.outputPaginator;
    this.pageIndexOutputs = this.outputPaginator?.pageIndex;
    this.pageSizeOutputs = this.outputPaginator?.pageSize;

    this.sortCamera?.active;
    this.deviceSort?.active;
    this.outputSort?.active;
    this.strobeSort?.active;

    this.dataSourceCamera.sort = this.sortCamera;
    this.dataSourceDevice.sort = this.deviceSort;
    this.dataSourceOutputs.sort = this.outputSort;
    this.dataSourceStrobes.sort = this.strobeSort;

    this.sortCamera?.direction;
    this.deviceSort?.direction;
    this.outputSort?.direction;
    this.strobeSort?.direction;
    this.sortCamera?.sortChange.subscribe(() => (this.paginatorCamera.pageIndex = 0));
    this.deviceSort?.sortChange.subscribe(() => (this.devicePaginator.pageIndex = 0));
    this.outputSort?.sortChange.subscribe(() => (this.outputPaginator.pageIndex = 0));
    this.strobeSort?.sortChange.subscribe(() => (this.strobePaginator.pageIndex = 0));
  }

  /**Function call when changing the Tabs */
  changeTab(event: any) {
    localStorage.setItem("selectedTab", event);
    if (event === 2) {
      this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
    }
  }

  /**Get site by potential ID */
  siteByPotentialID() {
    if (this.potentialId) {
      this.spinner.activate();
      this.loading = true;
      this.camService.getSiteByPotentialId(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          sessionStorage.setItem("siteData", JSON.stringify(response.data?.potentialInfo));
          this.siteInfo = response.data?.potentialInfo;
          let timeStamp = response.data?.potentialInfo?.lastModifiedTime?.replace(/\./g, ' ')?.split(" ")[0] + response.data?.potentialInfo?.lastModifiedTime?.replace(/\./g, ' ')?.split(" ")[1];
          let timeStampNum = Number(timeStamp);
          let fullDateTime: any = this.timeZoneService.getDateParametersByTimeZone(timeStampNum);
          this.lastModifiedTime = fullDateTime['currentTime'].split(' ')[1] + " " + fullDateTime['displayCode'];
          this.potentialId = response.data?.potentialInfo?.vtigerPotentialId;
          this.potentialName = response.data?.potentialInfo?.potentialName;
          this.accountId = response.data?.potentialInfo?.accInfo?.vtigerAccountId;
          this.monitoringHours = response.data?.potentialInfo?.monitoringHours;
          this.aditionalhours = response.data?.potentialInfo?.addMonitoringHours;
          this.monitoringService = response.data?.potentialInfo?.monitoringService;
          this.monitoredCamera = response.data?.potentialInfo?.monitoring;
          this.stopCaptureOutsideMonitor = response.data?.potentialInfo?.solarScriptExempt;
          this.evntMonitoring = response.data?.potentialInfo?.monitoring;
          this.siteStatus = response.data?.potentialInfo?.status;
          this.company = response.data?.potentialInfo?.accInfo?.industry;
          this.siteJobs = response.data?.potentialInfo?.accInfo?.industry;
          this.secondarySecurity = response.data?.potentialInfo?.accInfo?.sss;
          this.sssContact = response.data?.potentialInfo?.accInfo?.sssContact;
          this.ouatageNotificationMethods = response.data?.potentialInfo?.accInfo?.outageNotificationMethod;
          this.unitId = response.data?.potentialInfo?.unitId;
          this.polishDepartmentName = response.data?.potentialInfo?.accInfo?.policeDeptName;
          this.installationType = response.data?.potentialInfo?.installationId;
          this.fieldServicRep = response.data?.potentialInfo?.salesRep;
          this.occupied = response.data?.potentialInfo?.accInfo?.occupied === 0 ? false : true;
          this.emergencyPrimaryContact = response.data?.potentialInfo?.accInfo?.emergencyContact1;
          this.emergencySecondaryContact = response.data?.potentialInfo?.accInfo?.emergencyContact2;
          this.address = response.data?.potentialInfo?.accInfo?.address;
          this.emailAddresss = response.data?.potentialInfo?.accInfo?.customerEmail;
          this.city = response.data?.potentialInfo?.accInfo?.city;
          this.safeWard = response.data?.potentialInfo?.accInfo?.safeWord;
          this.crossStreet = response.data?.potentialInfo?.accInfo?.crossStreet1;
          this.crossStreet2 = response.data?.potentialInfo?.accInfo?.crossStreet2;
          this.zip = response.data?.potentialInfo?.accInfo?.zipCode;
          this.state = response.data?.potentialInfo?.accInfo?.state;
          this.internetSource = "";
          this.contactOwnerFirst = response.data?.potentialInfo?.accInfo?.contactOwner === "0" ? false : true;
          this.localPolish = response.data?.potentialInfo?.accInfo?.localPoliceNumber;
          this.alarmBusinessLicence = "";
          this.alarmCustomerLicence = "";
          this.gateCode = response.data?.potentialInfo?.accInfo?.gateCode;
          this.gaurdTourTime = "";
          this.description = response.data?.potentialInfo?.accInfo?.description;
          this.selectedAnalyticPlateformID = response.data?.potentialInfo?.analyticId;
          this.uploadedPriviewImageFile = response.data?.potentialInfo?.s3Url;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /**Get all camera related to particular site based on the site potential ID */
  getCameraListForSite(pageSize: any, pageIndex: any, searchCameraFilterVal: any) {
    this.dataSourceCamera = new MatTableDataSource<any>([]);
    if (this.potentialId) {
      this.spinner.activate();
      this.isLoadingCamera = true;
      this.camService.getCamByPotentialId(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.isLoadingCamera = false;
          this.dataSourceCamera = new MatTableDataSource<any>(response?.data?.cams !== null ? response?.data?.cams : []);
          this.dataSourceCamera.paginator = this.paginatorCamera;
          this.totalRecordsCamera = response?.data?.totalRecords;
          this.dataSourceCamera.sort = this.sortCamera;
          this.dayImageUrl = response?.data?.cams !== null ? response?.data?.cams[this.indexNoOfSelectedCam]?.dayImage : '';
          this.nightImageUrl = response?.data?.cams !== null ? response?.data?.cams[this.indexNoOfSelectedCam]?.nightImage : '';
          if (response?.data?.cams !== null) {
            if (JSON.parse(sessionStorage.getItem("selectedCamObjectInViews"))) {
              this.selectedCamObjectViews = JSON.parse(sessionStorage.getItem("selectedCamObjectInViews"));
              response?.data?.cams?.map((item: any, index: any) => {
                if (item.camUniqueId === this.selectedCamObjectViews?.camUniqueId) {
                  this.indexNoOfSelectedCam = index;
                  this.dayImageUrl = this.selectedCamObjectViews?.dayImage || item?.dayImage || response?.data?.cams !== null ? response?.data?.cams[index]?.dayImage : '';
                  this.nightImageUrl = this.selectedCamObjectViews?.nightImage || item?.nightImage || response?.data?.cams !== null ? response?.data?.cams[index]?.nightImage : '';
                  return;
                }
              })
            } else {
              this.selectedCamObjectViews = response?.data?.cams?.[0]
              this.indexNoOfSelectedCam = 0;
              this.dayImageUrl = response?.data?.cams !== null ? response?.data?.cams[0]?.dayImage : '';
              this.nightImageUrl = response?.data?.cams !== null ? response?.data?.cams[0]?.nightImage : '';
            }
            this.cameraListForSite = response?.data?.cams || [];
            this.selectedCameraName = response?.data?.cams?.[0]?.cameraName;
            this.selectedCameraUniqueId = response?.data?.cams?.[0]?.camUniqueId;
            this.selectedCameraStatus = response?.data?.cams?.[0]?.connected;
          } else {
            this.cameraListForSite = [];
          }
        } else {
          this.spinner.deactivate();
          this.isLoadingCamera = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.isLoadingCamera = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /**Get all devices  */
  getAllDevices() {
    if (this.potentialId) {
      this.spinner.activate();
      this.loading = true;
      this.camService.getAllDevices(this.potentialId).subscribe((response: any) => {
        if (response && response.success) {
          let SITE_NAME = response?.data?.siteName;
          let otherDeviceListWithSiteName = [];
          let outputListWithSiteName = [];
          let strobesListWithSiteName = [];
          if (response?.data?.otherDeviceList !== null) {
            otherDeviceListWithSiteName = response?.data?.otherDeviceList?.map((item: any) => {
              return { ...item, siteName: SITE_NAME }
            })
          }
          if (response?.data?.outputDataList !== null) {
            outputListWithSiteName = response?.data?.outputDataList?.map((item: any) => {
              return { ...item, siteName: SITE_NAME }
            })
          }
          if (response?.data?.strobeDataList !== null) {
            strobesListWithSiteName = response?.data?.strobeDataList?.map((item: any) => {
              return { ...item, siteName: SITE_NAME }
            })
          }
          this.dataSourceDevice = new MatTableDataSource<any>(otherDeviceListWithSiteName || []);
          this.dataSourceDevice.paginator = this.devicePaginator;
          this.totalRecordsDevice = response?.data?.otherDeviceList?.length || []?.length;
          this.dataSourceDevice.sort = this.deviceSort;

          this.dataSourceOutputs = new MatTableDataSource<any>(outputListWithSiteName || []);
          this.dataSourceOutputs.paginator = this.outputPaginator;
          this.totalRecordsOutputs = response?.data?.outputDataList?.length || []?.length;
          this.dataSourceOutputs.sort = this.outputSort;

          this.dataSourceStrobes = new MatTableDataSource<any>(strobesListWithSiteName || []);
          this.dataSourceStrobes.paginator = this.strobePaginator;
          this.totalRecordsStrobes = response?.data?.strobeDataList?.length || []?.length;
          this.dataSourceStrobes.sort = this.strobeSort;

          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }
  }

  /** This will call when user select the particuler device type. */
  handleGetDeviceByClass() {
    this.spinner.activate();
    this.loading = true;
    this.selectionDevice = new SelectionModel<TableElementDevice>(true, []);
    this.selectionOutputs = new SelectionModel<TableElementOutputs>(true, []);
    this.selectionStrobes = new SelectionModel<TableElementStrobes>(true, []);
    if (this.selectDeviceConfiguration) {
      this.camService.getDeviceByClass(this.potentialId, this.selectDeviceConfiguration).subscribe((response: any) => {
        if (response && response.success) {
          let SITE_NAME = response?.data?.siteName;
          let otherDeviceListWithSiteName = [];
          let outputListWithSiteName = [];
          let strobesListWithSiteName = [];
          if (this.selectDeviceConfiguration === "OTHER_DEVICE_DATA") {
            if (response?.data?.otherDeviceList !== null) {
              otherDeviceListWithSiteName = response?.data?.otherDeviceList?.map((item: any) => {
                return { ...item, siteName: SITE_NAME }
              })
            }
            this.dataSourceDevice = new MatTableDataSource<any>(otherDeviceListWithSiteName || []);
            this.dataSourceDevice.paginator = this.devicePaginator;
            this.totalRecordsDevice = response?.data?.totalRecords || []?.length;
            this.dataSourceDevice.sort = this.deviceSort;
          } else if (this.selectDeviceConfiguration === "OUTPUT_DATA") {
            if (response?.data?.outputDataList !== null) {
              outputListWithSiteName = response?.data?.outputDataList?.map((item: any) => {
                return { ...item, siteName: SITE_NAME }
              })
            }
            this.dataSourceOutputs = new MatTableDataSource<any>(outputListWithSiteName || []);
            this.dataSourceOutputs.paginator = this.outputPaginator;
            this.totalRecordsOutputs = response?.data?.totalRecords || []?.length;
            this.dataSourceOutputs.sort = this.outputSort;
          } else if (this.selectDeviceConfiguration === "STROBE_DATA") {
            if (response?.data?.strobeDataList !== null) {
              strobesListWithSiteName = response?.data?.strobeDataList?.map((item: any) => {
                return { ...item, siteName: SITE_NAME }
              })
            }
            this.dataSourceStrobes = new MatTableDataSource<any>(strobesListWithSiteName || []);
            this.dataSourceStrobes.paginator = this.strobePaginator;
            this.totalRecordsStrobes = response?.data?.totalRecords || []?.length;
            this.dataSourceStrobes.sort = this.strobeSort;
          }
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    }

  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceCamera.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSourceCamera.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: TableElementCamera): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.unique_id + 1}`;
  }


  /** Whether the number of selected elements matches the total number of rows. Device*/
  isAllSelectedDevice() {
    const numSelected = this.selectionDevice.selected.length;
    const numRows = this.dataSourceDevice.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. Device */
  masterToggleDevice() {
    this.isAllSelectedDevice() ? this.selectionDevice.clear() : this.dataSourceDevice.data.forEach(row => this.selectionDevice.select(row));
  }

  /** The label for the checkbox on the passed row Device */
  checkboxLabelDevice(row?: TableElementDevice): string {
    if (!row) {
      return `${this.isAllSelectedDevice() ? 'deselect' : 'select'} all`;
    }
    return `${this.selectionDevice.isSelected(row) ? 'deselect' : 'select'} row ${row.deviceUniqueId + 1}`;
  }

  /** Whether the number of selected elements matches the total number of rows. Outputs*/
  isAllSelectedOutputs() {
    const numSelected = this.selectionOutputs.selected.length;
    const numRows = this.dataSourceOutputs.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. Outputs */
  masterToggleOutputs() {
    this.isAllSelectedOutputs() ? this.selectionDevice.clear() : this.dataSourceOutputs.data.forEach(row => this.selectionOutputs.select(row));
  }

  /** The label for the checkbox on the passed row Outputs */
  checkboxLabelOutputs(row?: TableElementOutputs): string {
    if (!row) {
      return `${this.isAllSelectedOutputs() ? 'deselect' : 'select'} all`;
    }
    return `${this.selectionOutputs.isSelected(row) ? 'deselect' : 'select'} row ${row.deviceUniqueId + 1}`;
  }

  /** Whether the number of selected elements matches the total number of rows. Strobes*/
  isAllSelectedStrobes() {
    const numSelected = this.selectionStrobes.selected.length;
    const numRows = this.dataSourceStrobes.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. Strobes */
  masterToggleStrobes() {
    this.isAllSelectedStrobes() ? this.selectionDevice.clear() : this.dataSourceStrobes.data.forEach(row => this.selectionStrobes.select(row));
  }

  /** The label for the checkbox on the passed row Strobes */
  checkboxLabelStrobes(row?: TableElementStrobes): string {
    if (!row) {
      return `${this.isAllSelectedStrobes() ? 'deselect' : 'select'} all`;
    }
    return `${this.selectionStrobes.isSelected(row) ? 'deselect' : 'select'} row ${row.deviceUniqueId + 1}`;
  }

  applyCameraFilter(event: any) {
    setTimeout(() => {
      this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
    }, 1000)
    if (this.dataSourceCamera.paginator) {
      this.dataSourceCamera.paginator.firstPage();
    }
  }

  /** This methods is used for deleteing the camera from site */
  removeCamera() {
    let popupData = {
      title: "Delete Confirmation",
      message: `Are you sure you want to delete these ${this.selection?.selected?.length} ${(this.selection?.selected?.length <= 1) ? 'camera?' : 'cameras?'}`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        //this data return true if user click on Yes, and if No the return false
        this.spinner.activate();
        this.loading = true;
        this.selection?.selected?.map((item: any) => {
          return this.camService.deleteCam(item.camUniqueId).subscribe((response: any) => {
            if (response && response.success) {
              this.spinner.deactivate();
              this.loading = false;
              this.toastr.success(`${(this.selection?.selected?.length > 1) ? 'Cameras' : 'Camera'} deleted successfully`);
              this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
              this.selection.clear();
            } else {
              this.spinner.deactivate();
              this.loading = false;
              this.toastr.error(response?.messages[0] || AppConstants.defaultErrorMessage);
            }
          }, (err) => {
            this.spinner.deactivate();
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          })
        })
      }
    })
  }

  changePaging(event: any) {
    this.pageIndexCamera = event.pageIndex;
    this.pageSizeCamera = event.pageSize;
    this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
    this.selection.clear();
  }

  selectedRow(event: any, row: any) {
    event.stopPropagation();
    // this.router.navigate(["/camera-server/update-camera-list"])
  }

  changePagingDevice(event: any) {
    this.pageIndexDevice = event.pageIndex;
    this.pageSizeDevice = event.pageSize;
    this.selectionDevice.clear();
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }
  selectedRowDevice(event: any, row: any) {
    event.stopPropagation();
    // this.router.navigate(["/camera-server/update-camera-list"])
  }

  changePagingOutputs(event: any) {
    this.pageIndexOutputs = event.pageIndex;
    this.pageSizeOutputs = event.pageSize;
    this.selectionOutputs.clear();
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  selectedRowOutputs(event: any, row: any) {
    event.stopPropagation();
    // this.router.navigate(["/camera-server/update-camera-list"])
  }

  changePagingStrobes(event: any) {
    this.pageIndexStrobes = event.pageIndex;
    this.pageSizeStrobes = event.pageSize;
    this.selectionStrobes.clear();
    // this.getPagedData(this.pageSize, this.pageIndex, this.searchCameraFilterValue);
  }

  selectedRowStrobes(event: any, row: any) {
    event.stopPropagation();
    // this.router.navigate(["/camera-server/update-camera-list"])
  }

  addCameraInSite() {
    const siteInfoData: any = sessionStorage.getItem("siteData") || {};
    const siteInfo: any = JSON.parse(siteInfoData);
    sessionStorage.setItem("isAddCameraInSite", "true");
    sessionStorage.setItem("isEditfromSite", "false");
    sessionStorage.setItem("isCameraEdit", "false");
    this.router.navigate([`/camera-server/sitelist/${siteInfo?.vtigerPotentialId}/addcamera`])
  }

  editCamera(element: any) {
    sessionStorage.setItem("camUniqueId", element.camUniqueId);
    sessionStorage.setItem("isAddCameraInSite", "false");
    sessionStorage.setItem("isEditfromSite", "true");
    sessionStorage.setItem("isCameraEdit", "false");
    this.router.navigate([`/camera-server/edit-camera-list/${element.camUniqueId}`])
  }

  handleCancelPageOrBack() {
    this._location.back();
  }

  removeDevice() {
    let popupData = {}
    if (this.selectionDevice?.selected?.length !== 0) {
      popupData = {
        title: "Delete Confirmation",
        message: `Are you sure you want to delete  ${this.selectionDevice?.selected?.length} ${(this.selectionDevice?.selected?.length <= 1) ? 'device?' : 'devices?'}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
    } else if (this.selectionOutputs?.selected?.length !== 0) {
      popupData = {
        title: "Delete Confirmation",
        message: `Are you sure you want to delete  ${this.selectionOutputs?.selected?.length} ${(this.selectionOutputs?.selected?.length <= 1) ? 'output?' : 'outputs?'}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
    } else if (this.selectionStrobes?.selected?.length !== 0) {
      popupData = {
        title: "Delete Confirmation",
        message: `Are you sure you want to delete  ${this.selectionStrobes?.selected?.length} ${(this.selectionStrobes?.selected?.length <= 1) ? 'strobe?' : 'strobes?'}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        //this data return true if user click on Yes, and if No the return false
        this.spinner.activate();
        this.loading = true;
        if (this.selectionDevice?.selected?.length !== 0) {
          this.selectionDevice?.selected?.map((item: any) => {
            return this.camService.deleteDevices(item.deviceUniqueId).subscribe((response: any) => {
              if (response && response.success) {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.success(response?.data?.message || "Device deleted successfully");
                this.getAllDevices();
                this.selectionDevice.clear();
              } else {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.error(response?.message[0] || AppConstants.defaultErrorMessage);
              }
            }, (err) => {
              this.spinner.deactivate();
              if (err && err.error && err.error.message && err.error.message.length > 0) {
                this.toastr.error(err.error.message, 'Error');
              } else {
                this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
              }
            })
          })
        } else if (this.selectionOutputs?.selected?.length !== 0) {
          this.selectionOutputs?.selected?.map((item: any) => {
            return this.camService.deleteDevices(item.deviceUniqueId).subscribe((response: any) => {
              if (response && response.success) {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.success(response?.data?.message || "Outputs device deleted successfully");
                this.getAllDevices();
                this.selectionOutputs.clear();
              } else {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.error(response?.message[0] || AppConstants.defaultErrorMessage);
              }
            }, (err) => {
              this.spinner.deactivate();
              if (err && err.error && err.error.message && err.error.message.length > 0) {
                this.toastr.error(err.error.message, 'Error');
              } else {
                this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
              }
            })
          })
        } else if (this.selectionStrobes?.selected?.length !== 0) {
          this.selectionStrobes?.selected?.map((item: any) => {
            return this.camService.deleteDevices(item.deviceUniqueId).subscribe((response: any) => {
              if (response && response.success) {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.success(response?.data?.message || "Strobes Data deleted successfully");
                this.getAllDevices();
                this.selectionStrobes.clear();
              } else {
                this.spinner.deactivate();
                this.loading = false;
                this.toastr.error(response?.message[0] || AppConstants.defaultErrorMessage);
              }
            }, (err) => {
              this.spinner.deactivate();
              if (err && err.error && err.error.message && err.error.message.length > 0) {
                this.toastr.error(err.error.message, 'Error');
              } else {
                this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
              }
            })
          })
        }
      }
    })
  }

  editDeviceInSite(element: any) {
    this.isEditDevice = true;
    sessionStorage.setItem("isAddOutputs", 'false');
    const dialofRef = this.dialog.open(DeviceDetailsDialogComponent, {
      width: '100%',
      data: element,
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      if (result === undefined) {
        this.handleGetDeviceByClass();
      }
    })
  }

  editOutputsInSite(element: any) {
    sessionStorage.setItem("isAddOutputs", 'false');
    const dialofRef = this.dialog.open(OutputsDetailsDialogComponent, {
      width: '100%',
      data: element,
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      if (result === undefined) {
        this.handleGetDeviceByClass();
      }
    })
  }

  editStrobesInSite(element: any) {
    sessionStorage.setItem("isAddOutputs", 'false');
    const dialofRef = this.dialog.open(StrobesDetailsDialogComponent, {
      width: '100%',
      data: element,
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      if (result === undefined) {
        this.handleGetDeviceByClass();
      }
    })
  }

  handleSelectAnalytic(event: any) {
    if (event) {
      this.isUpdateAnalyticPlatformBtn = false;
    }
  }

  handleUpdateAnalyticId() {
    const requestPayload: any = {
      potentialId: this.potentialId,
      analyticId: this.selectedAnalyticPlateformID
    }
    this.spinner.activate();
    this.loading = true;
    this.camService.updateAnalytic(requestPayload).subscribe((response: any) => {
      if (response && response.success) {
        this.toastr.success("Analytic platform updated.");
        this.spinner.deactivate();
        this.loading = false;
        this.isUpdateAnalyticPlatformBtn = true;
        this.siteByPotentialID();
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.warning(response.messages || AppConstants.defaultErrorMessage);
      }
    }, (err) => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }


  /** Methods for selecting camera from list in site plan */
  handleSelectCamera(event: MatSelectionListChange) {
    let selectedValue: any = {};
    event.source.selectedOptions.selected.map((o: MatListOption) => {
      return selectedValue = o.value;
    })
    this.dayImageUrl = selectedValue?.dayImage;
    this.nightImageUrl = selectedValue?.nightImage;
    this.selectedCameraName = selectedValue?.cameraName;
    this.selectedCameraUniqueId = selectedValue?.camUniqueId;
    this.selectedCameraStatus = selectedValue?.connected;
    this.isCameraSelected = true;
    if (selectedValue) {
      this.selectedCamObjectViews = selectedValue;
      sessionStorage.setItem("selectedCamObjectInViews", JSON.stringify(selectedValue));
    }
  }

  /** Select image and upload */
  selectSiteImageUpload(event: any) {
    this.selectSiteFile = event.target.files[0];
    if (event.target.files[0]) {
      this.uploadSiteImageFile();
    }
  }

  /** Upload site image API */
  uploadSiteImageFile() {
    const fileData: FormData = new FormData();
    fileData.append('siteImage', this.selectSiteFile);
    this.loading = true;
    this.spinner.activate();
    this.camService.uploadSiteImage(fileData, this.potentialId).subscribe(
      (response: any) => {
        if (response && response.success) {
          this.uploadedPriviewImageFile = response?.data?.s3Url;
          this.loading = false;
          this.spinner.deactivate();
          this.toastr.success('File upload successfully.');
          this.siteByPotentialID();
        } else {
          this.loading = false;
          this.spinner.deactivate();
          this.toastr.warning(AppConstants.defaultErrorMessage);
        }
      },
      (err) => {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    );
  }

  /** Add device in the selected site */
  addDeviceInSite() {
    const dialofRef = this.dialog.open(DeviceDetailsDialogComponent, {
      width: '100%',
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        if (result === undefined) {
          this.getAllDevices();
        }
      }, 1000)
    })
    sessionStorage.setItem("isAddOutputs", 'true');
  }

  /** Add Outputs in the selected site */
  addOutputsInSite() {
    const dialofRef = this.dialog.open(OutputsDetailsDialogComponent, {
      width: '100%',
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        if (result === undefined) {
          this.getAllDevices();
        }
      }, 1000)
    })
    sessionStorage.setItem("isAddOutputs", 'true');
  }

  /** Add Strobes in the selected site */
  addStrobesInSite() {
    const dialofRef = this.dialog.open(StrobesDetailsDialogComponent, {
      width: '100%',
      disableClose: true
    });
    dialofRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        if (result === undefined) {
          this.getAllDevices();
        }
      }, 1000)
    })
    sessionStorage.setItem("isAddOutputs", 'true');
  }

  /** Downloads the sites */
  handleDownloadSites() {
    this.loading = true;
    this.spinner.activate();
    this.camService.downloadSite(this.potentialId).subscribe(
      (response: any) => {
        this.downloadFile(response);
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.success('File Downloaded successfully.');
      },
      (err) => {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(err.message || 'Internal Server Error');
      }
    );
  }

  /** The  function for download Excel sheet the sites */
  downloadFile(data: Blob) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
    const url = window.URL.createObjectURL(blob);
    var anchor = document.createElement("a");
    anchor.download = `${this.potentialId}.xlsx`;
    anchor.href = url;
    anchor.click();
  }

  /** Get Masking Details methods */
  getMaskingDetails(event: any) {
    event.stopPropagation();
    sessionStorage.setItem("potentialId", this.potentialId);
    this.router.navigate([`/camera-server/masking`])
  }

  /** The  function called for confirmation manual site sync  */
  ManualSyncConfirmation() {
    let popupData = {
      title: "Confirmation?",
      message: `Are you sure you want to sync this site ?`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.handleManualSyncSites();
      }
    })
  }

  /** Function is used for open cockpit 1 dialog modal */
  openCockpitDialog(iframeUrl: any) {
    this.dialog.open(IframeModalComponent, {
      panelClass: 'view-camera',
      width: '100%',
      height: '80%',
      data: { iframeUrl },
      disableClose: true
    });
  }

  /** The  function for manual sync sites  */
  handleManualSyncSites() {
    this.loading = true;
    this.spinner.activate();
    this.camService.manualSyncSite(this.potentialId).subscribe((response: any) => {
      if (response && response.success) {
        this.loading = false;
        this.spinner.deactivate();
        for (const key in response?.data) {
          if (response?.data.hasOwnProperty(key)) {
            if (response?.data[key]) {
              this.toastr.success(`${key} - Data synced successfully`);
            } else {
              this.toastr.warning(`${key} - Not synced successfully`);
            }
          }
        }
        // this.toastr.success(response?.data?.success || 'Data synced successfully.');
        this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
        this.getAllDevices();
        this.siteByPotentialID();
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(response?.data || AppConstants.defaultErrorMessage);
      }
    },
      (err) => {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(err.message || AppConstants.defaultErrorMessage);
      }
    );
  }

  /** The  function for manual sync sites  */
  testOutput(element: any) {
    this.loading = true;
    this.spinner.activate();
    this.camService.testDevices(element.potentialId, element.deviceUniqueId).subscribe((response: any) => {
      if (response && response.success) {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.success(response?.data || 'Alarm triggered Successfully');
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(response?.data || AppConstants.defaultErrorMessage);
      }
    },
      (err) => {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(err.message || AppConstants.defaultErrorMessage);
      }
    );
  }

  /** Show the live view cameras */
  liveView(event: any) {
    const dialogRef = this.dialog.open(SiteCamLiveViewsComponent, {
      data: { vtigerPotentialId: this.potentialId, siteName: `${this.potentialName} (${this.potentialId})`, siteAccess: this.siteInfo?.siteAccess },
      disableClose: true,
      maxWidth: '95vw',
      maxHeight: '95vh',
      width: '100%',
      height: '100%',
      panelClass: 'full-screen-modal'
    });
  }

  /** Show the live view for single Camera */
  liveViewForSingleCamera(event: any, element: any) {
    const dialogRef = this.dialog.open(SiteCamLiveViewsComponent, {
      data: { vtigerPotentialId: this.potentialId, isSingleCam: [element], siteAccess: this.siteInfo?.siteAccess },
      disableClose: true,
      width: '50%',
      height: '85%',
      panelClass: 'full-screen-modal'
    });
  }

  /** Function call to import excel and add camera */
  importCamera(event: any) {
    const importCameraFile = event.target.files[0];
    this.fileExcelValidation(importCameraFile);
  }

  /** Function call to validate file is it excel or others */
  fileExcelValidation(file: any) {
    let fileName = file.name;
    let ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    if (ext === 'xls' || ext === 'xlsx') {
      this.importCameraFileError = false;
    } else {
      this.importCameraFileError = true;
    }
  }

  /** Function call to sync Day Night image for particular camera */
  manualSyncCameraDN() {
    if (this.selectedCameraStatus) {
      let popupData = {
        title: "Confirmation?",
        message: `Are you sure you want sync Day Night view for camera - ${this.selectedCameraName}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
      let dialog = this.ngbModalService.open(ConfirmationDialogueComponent);
      dialog.componentInstance._data = popupData;
      dialog.result.then(data => {
        if (data) {
          this.spinner.activate();
          const requestParam: any = {
            potentialId: this.potentialId,
            camUnqId: this.selectedCameraUniqueId,
            type: 'live'
          }
          this.camService.syncDayNightImageIndividualCam(requestParam).subscribe((response: any) => {
            if (response && response.success) {
              this.spinner.deactivate();
              this.toastr.success(response.data || "Successfully synced the Day Night views");
              this.getCameraListForSite(this.pageSizeCamera, this.pageIndexCamera, this.searchCameraFilterValue);
            } else {
              this.spinner.deactivate();
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          }, (err) => {
            this.spinner.deactivate();
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          })
        }
      })
    } else {
      this.toastr.error(`Camera -${this.selectedCameraName} is offline, Please try after some time.`, 'Error');
    }
  }

}
